import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
  copiedData: {},
};

const aboutEditSlice = createSlice({
  name: "aboutEdit",
  initialState,
  reducers: {
    updateAboutEditData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    },
    updateAboutEditCopiedData: (state, action) => {
      state.copiedData = { ...state.copiedData, ...action.payload };
    },
    resetAboutEditState: () => initialState,
  },
});

export const {
  updateAboutEditData,
  updateAboutEditCopiedData,
  resetAboutEditState,
} = aboutEditSlice.actions;

export default aboutEditSlice.reducer;
